// @flow

import _ from 'lodash';

import ApiError from '../entities/ApiError';

import Logger from './Logger';

class ApiErrorUtils {

 /**
  * Define the Generic errors of the API (cf GenericApiErrors file on the API).
  */
  static getGenericErrors() {
    // TODO: I18n
    return {
      '1001': 'invalid cursors', // should not happen

      '1002': 'Le code d\'élévation est invalide'
    }
  }

  /**
   * @private
   *
   * @param apiError
   * @param errors
   * @param label
   */
  static findErrorOnArray(apiError: ApiError, errors: Object, label: string): string {
    const message = errors[apiError.code];
    if (!_.isUndefined(message)) {
      return message;
    }

    const genericMessage = ApiErrorUtils.getGenericErrors()[apiError.code];
    if (!_.isUndefined(genericMessage)) {
      return genericMessage;
    }

    Logger.notImplemented(`${label} Unknown api error`, apiError);

    const codeMsg =  !_.isNil(apiError.code) ? `[${apiError.code}]` : '';
    const messageMsg = !_.isNil(apiError.message) ? `${apiError.message}` : '';

    // TODO: I18n.
    return `Erreur inconnue: ${codeMsg} ${messageMsg}`;
  }

}

export default ApiErrorUtils;



// WEBPACK FOOTER //
// ./sdk/scripts/utils/ApiErrorUtils.js